import React from "react";

const CheckboxInput = ({
  inputClassName = "",
  disabled = false,
  name,
  k = -1,
  checked = false,
  labelClassname = "",
  change = () => {},
  required = false,
  label = false,
  error = {},
  inputStyle = {},
  checkboxClassname = "",
  ...props
}) => {
  const valueChange = (e) => {
    var filteredValue = e.target.value;
    //console.log(filteredValue);
    let changeEvent = {
      target: {
        name: name,
        value: filteredValue,
        checked: e.target.checked,
        type: "checkbox",
        k: k,
      },
    };

    change(changeEvent);
  };

  return (
    <>
      <div
        className={`
          custom-control custom-switch  ${checkboxClassname}`}
        style={{ ...inputStyle }}
      >
        <input
          type="checkbox"
          className={"mr-2 custom-control-input" + inputClassName}
          disabled={disabled ? "disabled" : false}
          name={name}
          id={k != -1 ? "customSwitch" + name + "-" + k : "customSwitch" + name}
          onChange={valueChange}
          checked={checked ? "checked" : false}
        />

        <label
          className={"  custom-control-label  border-0 " + labelClassname}
          style={{ cursor: "pointer", minHeight: "0", padding: 0 }}
          htmlFor={k != -1 ? "customSwitch" + name + "-" + k : "customSwitch" + name}
        >
          {label && (
            <span className="mb-1 text-success" style={{}}>
              {label}
              {required && <span className="text-danger ml-1">*</span>}
            </span>
          )}
        </label>
        {props.info && (
          <div
            className="text-muted mt-2 mb-0 d-flex flex-column flex-md-row align-items-center justify-content-start"
            style={{
              fontWeight: "400",
              marginLeft: "-3.375rem",
            }}
          >
            {props.info}
          </div>
        )}
      </div>
      {error[name] && (
        <small
          className={
            "form-text font-weight-bold input-error-msg d-block text-danger animated flash"
          }
        >
          {error[name]}
        </small>
      )}
    </>
  );
};

export default CheckboxInput;
